<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <BusyTimeIndicatorThresholdTableButton @notice='notice'></BusyTimeIndicatorThresholdTableButton>
        <BusyTimeIndicatorThresholdTable ref="busyTimeIndicatorThreshold"></BusyTimeIndicatorThresholdTable>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import BusyTimeIndicatorThresholdTableButton from '../../components/alarmconfig/indicatorThreshold/BusyTimeIndicatorThresholdTableButton';
import BusyTimeIndicatorThresholdTable from '../../components/alarmconfig/indicatorThreshold/BusyTimeIndicatorThresholdTable';

export default {
  name: "BusyTimeIndicatorThresholdPage",
  components:{
    BasicLayout,
    BusyTimeIndicatorThresholdTableButton,
    BusyTimeIndicatorThresholdTable
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.indicatorThreshold')}`
      }
    };
  },
  methods: {
    notice(type) {
      switch (type) {
        case 'add':
          this.$refs.busyTimeIndicatorThreshold.addFunc();
          break;
        case 'remove':
          this.$refs.busyTimeIndicatorThreshold.removeFunc();
          break;
        case 'edit':
          this.$refs.busyTimeIndicatorThreshold.editFunc();
          break;
        case 'refresh':
          this.$refs.busyTimeIndicatorThreshold.getBusyTimeIndicatorAlarmThresholdListData();
          break;
        case 'able':
          this.$refs.busyTimeIndicatorThreshold.updateStatusFunc('1');
          break;
        case 'disable':
          this.$refs.busyTimeIndicatorThreshold.updateStatusFunc('0');
          break;
        default:
      }
    }
  }
}
</script>

<style scoped>

</style>
